import PublicNav from '../components/layout/PublicNav';
import PublicFooter from '../components/layout/PublicFooter';

const POSTS = [
  { title: '5 Ways to Improve Your Credit Score Before Applying for a Loan', tag: 'Credit', date: 'Coming soon' },
  { title: 'How Group Ajo Works — and Why It Still Matters in 2026', tag: 'Savings', date: 'Coming soon' },
  { title: 'A Beginner\'s Guide to Reading Your Loan Offer', tag: 'Loans', date: 'Coming soon' },
];

export default function Blog() {
  return (
    <div style={{ background: 'transparent', color: 'var(--text-1)', minHeight: '100vh', fontFamily: 'Inter, sans-serif', display: 'flex', flexDirection: 'column' }}>
      <PublicNav />

      <main style={{ flex: 1 }}>

      <section style={{ padding: '4.5rem 5% 2.5rem', textAlign: 'center' }}>
        <div style={{ fontSize: '0.7rem', fontWeight: 700, color: '#818CF8', textTransform: 'uppercase', letterSpacing: '0.12em', marginBottom: '0.75rem' }}>Blog</div>
        <h1 style={{ fontSize: 'clamp(1.8rem,3.5vw,2.6rem)', fontWeight: 900, fontFamily: 'Space Grotesk, sans-serif', letterSpacing: '-0.02em', marginBottom: '1rem' }}>
          Insights on money, made simple
        </h1>
        <p style={{ fontSize: '0.95rem', color: 'var(--text-2)' }}>We're just getting started — new articles are on the way.</p>
      </section>

      <section style={{ padding: '0 5% 5rem' }}>
        <div style={{ maxWidth: 900, margin: '0 auto', display: 'grid', gap: '1rem' }}>
          {POSTS.map(({ title, tag, date }) => (
            <div key={title} style={{ padding: '1.5rem', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1rem', flexWrap: 'wrap', opacity: 0.75 }}>
              <div>
                <div style={{ fontSize: '0.7rem', fontWeight: 700, color: '#818CF8', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '0.4rem' }}>{tag}</div>
                <div style={{ fontSize: '1rem', fontWeight: 700 }}>{title}</div>
              </div>
              <span style={{ fontSize: '0.75rem', color: 'var(--text-3)', flexShrink: 0 }}>{date}</span>
            </div>
          ))}
        </div>
      </section>

      </main>

      <PublicFooter />
    </div>
  );
}
